import { AxiosResponse, AxiosError } from "axios";

import { RESERVE_API_ENDPOINTS } from "@/features/reserves/api/endpointsReserve";
import { ReserveBaseModel } from "@/features/reserves/types/reserveModels";
import apiRequests from "@/shared/config/axiosConfig";

/**
 * Updates a reserve by its ID.
 * @param reserve The reserve to update.
 * @returns A Promise that resolves to the updated ReserveBaseModel object.
 * @throws An error if the request fails or returns an error status code.
 */
export default async function editReserve(
  reserve: ReserveBaseModel
): Promise<ReserveBaseModel> {
  try {
    if (!reserve.id) {
      throw new Error("Reserve ID is undefined");
    }

    const url = RESERVE_API_ENDPOINTS.UPDATE_RESERVE.replace("{reserveId}", reserve.id);
    const response: AxiosResponse<ReserveBaseModel> = await apiRequests.put(url, reserve);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
